<div id="js-enterDialogBg" [ngClass]="{enterDialogBackgroundMobile: isMobile, enterDialogBackground: !isMobile}"></div>
<div class="enterDialog">
    <mat-dialog-content class="enterDialog__notice" [ngClass.xs]="'w-mobile'" [ngClass.gt-xs]="'w-desktop'" >
        <div class="enter-text">
            This website may contain nudity, adult language and explicit sexual content. It should be accessed only by adults over the age of 18
        </div>
    </mat-dialog-content>
    <mat-dialog-actions class="enterDialog__actions pb-4">
        <button class="enterDialog__btExit"  mat-raised-button mat-dialog-close>Exit</button>
        <button class="enterDialog__btOver18" mat-raised-button (click)="onOver18()">I'm over 18 years old *</button>
    </mat-dialog-actions>
    <mat-dialog-content class="enterDialog__accesNotice">
        <div class="enterDialog__orOver mt-3">
            <span>*or over the age of consent in the jurisdiction from which it is being accessed</span>
        </div>
    </mat-dialog-content>
</div>

